module.exports = "https://s.pinimg.com/webapp/style/images/bg_business_account_convert-974d766b.jpg";